import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  ButtonGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  Slider
} from '@material-ui/core'
import {
  Reply,
  Visibility,
  InfoOutlined,
  AccountTree,
  SignalCellularAlt,
  Delete,
  DragIndicatorRounded,
  AccessTime,
  LocalOffer,
  SaveAlt,
  LineStyle,
  ArrowDropDownCircleRounded,
  PlayCircleFilled
} from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import {
  useGlobalContext,
  layerVisibilityChanged,
  layerDeleted,
  layerIcludeNameChanged,
  layerIncludeValueChanged,
  layerSliderChanged,
  layerButtonColors,
  sideBarRightVisibilityChanged,
  layerUpdated
} from '../../state'
import { useMapEngine } from '../shared'
import { MAP_ID } from '../../utils/apiHelper'
import { rangeColors } from '../../utils/configQueries'
import { t } from '../../utils/languages'
import { Dimensions } from '../Menu/MenuIndicator/Dimensions'
import {
  getIndicatorParams,
  useLayerIndicator,
  getPaintIndicator
} from '../../utils/indicatorHelper'

import { useStyles } from './styles'

import { useLayer } from '@facility-latam/geoportal-components'

const saveData = ({ geojson }) => {
  const a = document.createElement('a')
  const blob = new File([JSON.stringify(geojson)], 'layer.geojson')
  const url = window.URL.createObjectURL(blob)
  a.href = url
  a.download = blob.name
  a.click()
  window.URL.revokeObjectURL(blob)
}

export const SelectedLayer = ({ layer, dragProvided }) => {
  const {
    state: {
      language,
      sideBarRight: { selectedType }
    },
    dispatch
  } = useGlobalContext()
  const {
    id,
    isVisible,
    name,
    description,
    params,
    clasifications,
    indicatorId,
    includeName,
    includeValue,
    opacity,
    steps,
    dimensions,
    membersValues,
    isCountry,
    layerType
  } = layer

  const classes = useStyles()
  const colors = rangeColors.map((c) => c[4])
  const [engine] = useMapEngine(MAP_ID)
  const [geojson, setGeojson] = useState()
  const [showDimensions, setShowDimensions] = useState(false)

  const [newIndicator, setNewIndicator] = useState({
    id: 'emptyLayer',
    type: '',
    paint: {},
    dataIndicator: null,
    steps: null
  })

  useLayerIndicator({ newIndicator })

  const updatedLayer = async (values, last) => {
    dispatch(
      sideBarRightVisibilityChanged({
        selectedType: 'null'
      })
    )
    const dimensionType = Object.values(values).filter((k) => !parseInt(k))

    // cities_depualc is the only circle type layer (for the moment)
    const currentLayerType = last
      ? layerType
      : dimensionType.includes('cities_depualc')
      ? 'circle'
      : 'fill'

    const members = last ? [] : Object.values(values).filter((k) => parseInt(k))

    const {
      geojson,
      steps: stepsAux,
      stepsColor,
      metadata
    } = await getIndicatorParams({
      indicatorId,
      members,
      isCountry,
      dimensionType
    })

    setNewIndicator({
      id,
      type: currentLayerType,
      paint: getPaintIndicator.get(currentLayerType),
      dataIndicator: geojson,
      steps: stepsAux,
      stepsColor
    })
    dispatch(
      sideBarRightVisibilityChanged({
        isOpen: true,
        selectedType
      })
    )

    dispatch(
      layerUpdated({
        id,
        membersValues: last ? [] : values,
        metadata,
        steps: stepsAux
      })
    )
  }

  // change values layer in map
  const [setValuesLayer] = useLayer({
    engine,
    layer: {
      id: `layer-${id}`,
      type: 'symbol',
      source: `layer-${id}`,
      layout: {
        visibility: 'visible',
        'text-field': ['get', 'values'],
        'text-font': ['Open Sans Regular'],
        'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto'
      }
    }
  })

  // get geojson in source according to membersValues
  // and change values layers
  useEffect(() => {
    if (engine) {
      const _geojson = engine.getSource(id)._data
      if (_geojson) {
        setGeojson(_geojson)
        const { type, features } = _geojson
        const data = features.map(
          ({ type, properties: { long, lat, values } }) => ({
            type,
            properties: { values },
            geometry: { type: 'Point', coordinates: [long, lat] }
          })
        )
        const dataFormat = { features: data, type }
        setValuesLayer(isCountry ? dataFormat : _geojson)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engine, id, membersValues, setValuesLayer])

  // change values visibility
  useEffect(() => {
    if (engine) {
      engine.setLayoutProperty(
        `layer-${id}`,
        'visibility',
        isVisible && includeValue ? 'visible' : 'none'
      )
    }
  }, [id, includeValue, isVisible, engine])

  // change layer visibility
  useEffect(() => {
    if (engine) {
      engine.setLayoutProperty(id, 'visibility', isVisible ? 'visible' : 'none')
    }
  }, [id, isVisible, engine])

  // change layer colors
  useEffect(() => {
    if (engine) {
      engine.setPaintProperty(
        id,
        `${layerType === 'circle' ? 'circle-color' : 'fill-color'}`,
        ['step', ['get', 'values'], ...steps, 'red']
      )
    }
  }, [id, steps, engine, layerType])

  // TODO: change inlinestyle to makestyles
  return (
    <Accordion expanded={isVisible} style={{ margin: 5 }}>
      <AccordionSummary
        style={{
          cursor: 'default',
          backgroundColor: 'white',
          width: '100%'
        }}
      >
        <Box className={classes.containerSummary}>
          <Box className={classes.detailsSummary}>
            <Typography variant="subtitle1">{name}</Typography>
            <Typography variant="h5">{description}</Typography>
            {params.map(({ dimensionName: paramName, value }, index) => (
              <Box
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'left'
                }}
              >
                <Typography variant="body1">
                  {paramName}
                  :&nbsp;
                </Typography>
                <Typography variant="body1">{value}</Typography>
              </Box>
            ))}
          </Box>
          <Box className={classes.optionsSummary}>
            <IconButton
              onClick={() =>
                dispatch(layerVisibilityChanged({ id, isVisible: !isVisible }))
              }
              className={classes.iconBtn}
            >
              {isVisible ? (
                <PlayCircleFilled className={classes.icon} />
              ) : (
                <ArrowDropDownCircleRounded className={classes.icon} />
              )}
            </IconButton>
            <IconButton
              onClick={() => {
                dispatch(layerVisibilityChanged({ id, isVisible: false }))
                setTimeout(() => dispatch(layerDeleted({ id })), 0)
              }}
              aria-label="Delete"
              className={classes.iconBtn}
            >
              <Delete className={classes.icon} />
            </IconButton>

            {/* This prop allows dragging from a child component */}
            <IconButton
              aria-label="DragIndicatorRounded"
              {...dragProvided.dragHandleProps}
              className={classes.iconBtn}
            >
              <DragIndicatorRounded className={classes.icon} />
            </IconButton>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          {clasifications.map(({ color, from, to }, index) => (
            <Box
              key={index}
              style={{
                display: 'flex',
                justifyContent: 'left',
                paddingTop: 15
              }}
            >
              <Box
                style={{
                  backgroundColor: color,
                  width: 30,
                  height: 30,
                  marginRight: 30
                }}
              />
              <Typography>{`${t('Desde')} ${from} ${t(
                'Hasta'
              )} ${to}`}</Typography>
            </Box>
          ))}
          <ButtonGroup className={classes.btnContainer}>
            <Button
              className={classes.button2}
              onClick={() => setShowDimensions(!showDimensions)}
            >
              <Reply />
              <Typography style={{ textAlign: 'center' }} variant="caption">
                {t('Cambie dimensiones del indicador')}
              </Typography>
            </Button>
            <Button
              target="_blank"
              // eslint-disable-next-line max-len
              href={`https://statistics.cepal.org/portal/cepalstat/dashboard.html?lang=${language}&indicator_id=${indicatorId}&area_id=119`}
              className={classes.button2}
            >
              <SignalCellularAlt />
              <Typography style={{ textAlign: 'center' }} variant="caption">
                {t('Visualice el indicador en el Dashboard')}
              </Typography>
            </Button>
            <Button
              className={classes.button2}
              disabled={isCountry}
              onClick={() => !isCountry && updatedLayer({}, true)}
            >
              <AccountTree />
              <Typography style={{ textAlign: 'center' }} variant="caption">
                {t('Mostrar el último dato disponible para cada país')}
              </Typography>
            </Button>
          </ButtonGroup>
          {showDimensions && (
            <Box>
              <Dimensions
                defaultValues={membersValues}
                onAddLayer={updatedLayer}
              >
                {dimensions.filter(({ id }) => id !== 79515)}
              </Dimensions>
            </Box>
          )}
          <Typography style={{ marginTop: 10 }}>
            {t('Personalice su mapa')}
          </Typography>
          <Switch
            checked={includeName}
            onChange={() =>
              dispatch(
                layerIcludeNameChanged({
                  id,
                  includeName: !includeName
                })
              )
            }
          />
          <Typography variant="overline">{t('Incluir nombres')}</Typography>
          <LocalOffer className={classes.icon} />

          <Switch
            checked={includeValue}
            onChange={() =>
              dispatch(
                layerIncludeValueChanged({
                  id,
                  includeValue: !includeValue
                })
              )
            }
          />
          <Typography variant="overline">{t('Incluir valor')}</Typography>
          <LocalOffer className={classes.icon} />

          <ButtonGroup>
            {colors.map((color, n) => (
              <Button
                key={n}
                onClick={() => dispatch(layerButtonColors({ id, idPaint: n }))}
                className={classes.btnColors}
                style={{ backgroundColor: color }}
              />
            ))}
          </ButtonGroup>
          <Box className={classes.sliderContainer}>
            <Slider
              min={0}
              max={100}
              value={opacity}
              valueLabelDisplay="auto"
              onChange={(_, newValue) =>
                dispatch(layerSliderChanged({ id, opacity: newValue }))
              }
            />
            <Visibility className={classes.icon} />
          </Box>

          <hr />
          <ButtonGroup
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr'
            }}
          >
            <Button
              onClick={() => {
                dispatch(
                  sideBarRightVisibilityChanged({
                    isOpen: true,
                    selectedType: 'indicatorDefinition'
                  })
                )
              }}
              className={classes.buttonsf}
            >
              <InfoOutlined />
            </Button>
            <Button
              onClick={() => {
                dispatch(
                  sideBarRightVisibilityChanged({
                    isOpen: true,
                    selectedType: 'indicatorData'
                  })
                )
              }}
              className={classes.buttonsf}
            >
              <LineStyle />
            </Button>
            <Button className={classes.buttonsf}>
              <AccessTime />
            </Button>
            <Button
              onClick={() => saveData({ geojson })}
              className={classes.buttonsf}
            >
              <SaveAlt />
            </Button>
          </ButtonGroup>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
